/**
 * Save Jobs module
 
 * Used on Job Listing pages and Job page
 */

function updateSavedJobsCount(): void {
    const countElement = document.querySelector<HTMLElement>(".saved-jobs-count");

    if (!countElement) return;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- saved jobs data retrieved from localStorage has no static type definition
    const savedJobs = JSON.parse(
        localStorage.getItem("saved-jobs") ?? "[]"
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- accessing runtime property on untyped localStorage data
    countElement.innerHTML = `${savedJobs.length}&nbsp`;
}

export function initSaveJobs(containerSelector: string): void {
    const container = document.querySelector<HTMLElement>(containerSelector);

    if (!container) {
        return;
    }

    const jobSaveButtons = container.querySelectorAll<HTMLAnchorElement>('.job-save');

    if (jobSaveButtons.length == 0) {
        return;
    }

    updateSavedJobsCount();

    interface SavedJob {
        url: string;
        title: string;
        location: string;
        details: string;
        level: string;
        position: string;
        buttonText: string;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- saved jobs data retrieved from localStorage has no static type definition
    const savedJobs: SavedJob[] = JSON.parse(
        localStorage.getItem("saved-jobs") ?? "[]"
    );

    jobSaveButtons.forEach((saveBtn) => {

        // Add active state to jobs that are saved in local storage
        const jobContainer = saveBtn.closest(".job-title")?.parentElement;

        const href = jobContainer
            ?.querySelector<HTMLAnchorElement>("a.button__tertiary")
            ?.getAttribute("href");

        if (href && savedJobs.some(job => job.url === href)) {
            saveBtn.classList.add("active");
        }

        // Click funtcion for save job buttons

        saveBtn.addEventListener("click", () => {
            const jobContainer = saveBtn.closest(".job-title")?.parentElement;

            if (!jobContainer) return;

            const button = jobContainer.querySelector<HTMLAnchorElement>(
                "a.button__tertiary"
            );

            const href = button?.getAttribute("href");

            if (!href) return;

            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- saved jobs data retrieved from localStorage has no static type definition
            const savedJobs: SavedJob[] = JSON.parse(
                localStorage.getItem("saved-jobs") ?? "[]"
            );

            // If already active -> remove
            if (saveBtn.classList.contains("active")) {
                const updatedJobs = savedJobs.filter(
                    (job) => job.url !== href
                );

                localStorage.setItem(
                    "saved-jobs",
                    JSON.stringify(updatedJobs)
                );

                saveBtn.classList.remove("active");

                updateSavedJobsCount();

                return;
            }

            // Otherwise save
            const job: SavedJob = {
                url: href,
                title:
                    jobContainer.querySelector(".job-title span:first-child")
                        ?.textContent?.trim() ?? "",
                location:
                    jobContainer.querySelector(".job-location span")
                        ?.textContent?.trim() ?? "",
                details:
                    jobContainer.querySelector(".job-details span")
                        ?.textContent?.trim() ?? "",
                level:
                    jobContainer.querySelector(".job-level span")
                        ?.textContent?.trim() ?? "",
                position:
                    jobContainer.querySelector(".job-position span")
                        ?.textContent?.trim() ?? "",
                buttonText: button?.textContent?.trim() ?? "",
            };

            if (!savedJobs.some((saved) => saved.url === href)) {
                savedJobs.push(job);

                localStorage.setItem(
                    "saved-jobs",
                    JSON.stringify(savedJobs)
                );
            }

            saveBtn.classList.add("active");

            updateSavedJobsCount();
        });

        const clearJobsButton = document.querySelector<HTMLElement>(".clear-jobs");

        if (clearJobsButton) {
            clearJobsButton.addEventListener("click", () => {
                localStorage.removeItem("saved-jobs");
                updateSavedJobsCount();
            });
        }
    });
}
